import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Button from "../../../../components/button/Button";
import AuthTextInput from "../../../../components/inputs/authTextInput/AuthTextInput";
import DateInput from "../../../../components/inputs/dateInput/DateInput";
import ImagesDropdown from "../../../../components/inputs/imagesDropdown/ImagesDropdown";
import NumberInput from "../../../../components/inputs/numberInput/NumberInput";
import SelectInput from "../../../../components/inputs/selectInput/SelectInput";
import TextArea from "../../../../components/inputs/textArea/TextArea";
import Loader from "../../../../components/loader/Loader";
import SettingsPagesContainer from "../../../../components/settingsPagesContainer/SettingsPagesContainer";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { showConfirmationModal } from "../../../../features/confirmationModal/ConfirmationModalSlice";
import { fetchTournamentImages } from "../../../../features/images/tournamentImages/tournamentImagesSlice";
import { fetchTournamentsStatuses } from "../../../../features/tournaments/tournamentsSlice";
import { getUTCDateWithPeakTimeFromDate } from "../../../../utils/timeZone";
import styles from "./editTournament.module.css";

const EditTournament = () => {
  const location = useLocation();

  const {
    tournamentId: fetchedTournamentId,
    status: fetchedTournamentStatus,
    name: fetchedTournamentName,
    startDate: fetchedTournamentStartDate,
    description: fetchedTournamentDescription,
    enDescription: fetchedTournamentEnDescription,
    prize: fetchedTournamentPrize,
    tournamentImage: fetchedTournamentImage,
    prizeDescription: fetchedTournamentPrizeDescription,
    enPrizeDescription: fetchedTournamentEnPrizeDescription,
    liveLink: fetchedTournamentLiveLink,
  } = location.state;

  const date = new Date(fetchedTournamentStartDate);
  const formatedStartDate = date.toISOString().split("T")[0];

  const [tournamentStatus, setTournamentStatus] = useState(
    fetchedTournamentStatus
  );
  const [liveLink, setLiveLink] = useState(fetchedTournamentLiveLink);

  const [tournamentName, setTournamentName] = useState(fetchedTournamentName);

  const [startDate, setStartDate] = useState(formatedStartDate);
  const [description, setDescription] = useState(fetchedTournamentDescription);
  const [enDescription, setEnDescription] = useState(
    fetchedTournamentEnDescription
  );
  const [prize, setPrize] = useState(fetchedTournamentPrize);
  const [image, setImage] = useState(fetchedTournamentImage);
  const [prizeDescription, setprizeDescription] = useState(
    fetchedTournamentPrizeDescription
  );
  const [enPrizeDescription, setEnPrizeDescription] = useState(
    fetchedTournamentEnPrizeDescription
  );

  const dispatch = useDispatch();

  const { fetchStatusesStatus, statusesList } = useSelector(
    (state) => state.tournaments
  );

  const { fetchStatus: imagesFetchStatus, list: tournamentImages } =
    useSelector((state) => state.tournamentImages);

  const handleTournamentUpdate = () => {
    dispatch(
      showConfirmationModal({
        message: "هل انت متاكد من التعديل على البطولة ؟",
        data: {
          tournamentId: fetchedTournamentId,
          tournamentData: {
            name: tournamentName,
            status: tournamentStatus,
            startDate: getUTCDateWithPeakTimeFromDate(startDate),
            description: description,
            enDescription: enDescription,
            prize: prize,
            tournamentImage: image,
            prizeDescription: prizeDescription,
            enPrizeDescription: enPrizeDescription,
            liveLink: liveLink,
          },
        },
        actionType: "updateTournament",
      })
    );
  };

  useEffect(() => {
    if (fetchStatusesStatus === "idle") {
      dispatch(fetchTournamentsStatuses());
    }

    if (imagesFetchStatus === "idle") {
      dispatch(fetchTournamentImages());
    }
  }, [dispatch, fetchStatusesStatus, imagesFetchStatus]);

  if (fetchStatusesStatus === "loading" || imagesFetchStatus === "loading") {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <SettingsPagesContainer
        title={`التعديل على البطولة : ${fetchedTournamentName}`}
        fullHeight
        displayContainerClassName={styles.displayContainer}
      >
        <div className={styles.formLayout}>
          <div className={styles.fieldsWrapper}>
            <section className={styles.section}>
              <div className={styles.sectionHeader}>
                <TextWrapper textStyle="textMid">المعلومات الأساسية</TextWrapper>
              </div>
              <div className={styles.sectionGrid}>
                <div className={`${styles.inputWrapper} ${styles.fullSpan}`}>
                  <TextWrapper textStyle="textMid">اسم البطولة</TextWrapper>
                  <AuthTextInput
                    height="52px"
                    width="100%"
                    borderRadius="12px"
                    placeholder="اسم البطولة"
                    bgColor={"grey"}
                    value={tournamentName}
                    setValue={setTournamentName}
                  />
                </div>
                <div className={styles.inputWrapper}>
                  <TextWrapper textStyle="textMid">حالة البطولة</TextWrapper>
                  <SelectInput
                    placeHolder={"حالة البطولة"}
                    data={statusesList}
                    value={tournamentStatus}
                    setValue={setTournamentStatus}
                    wrapperClassName={styles.fullWidthField}
                    className={styles.fullWidthSelectButton}
                  >
                    {Array.isArray(statusesList) &&
                      statusesList.map((item) => {
                        return (
                          <option value={item} key={item}>
                            {item === "upcoming"
                              ? "قادمة"
                              : item === "live"
                                ? "مباشرة"
                                : "منتهية"}
                          </option>
                        );
                      })}
                  </SelectInput>
                </div>
                {tournamentStatus === "live" && (
                  <div className={`${styles.inputWrapper} ${styles.fullSpan}`}>
                    <TextWrapper textStyle="textMid">
                      رابط البث المباشر
                    </TextWrapper>
                    <AuthTextInput
                      height="52px"
                      width="100%"
                      borderRadius="12px"
                      placeholder="رابط البث المباشر"
                      bgColor={"grey"}
                      value={liveLink}
                      setValue={setLiveLink}
                    />
                  </div>
                )}
                <div className={styles.inputWrapper}>
                  <TextWrapper textStyle="textMid">تاريخ البداية</TextWrapper>
                  <DateInput
                    value={startDate}
                    setValue={setStartDate}
                    className={styles.fullWidthControl}
                  />
                </div>
              </div>
            </section>

            <section className={styles.section}>
              <div className={styles.sectionHeader}>
                <TextWrapper textStyle="textMid">الوصف والجوائز</TextWrapper>
              </div>
              <div className={styles.sectionGrid}>
                <div className={`${styles.inputWrapper} ${styles.fullSpan}`}>
                  <TextWrapper textStyle="textMid">وصف البطولة</TextWrapper>
                  <TextArea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                <div className={`${styles.inputWrapper} ${styles.fullSpan}`}>
                  <TextWrapper textStyle="textMid">
                    وصف البطولة بالانجليزية
                  </TextWrapper>
                  <TextArea
                    value={enDescription}
                    onChange={(e) => setEnDescription(e.target.value)}
                  />
                </div>
                <div className={styles.inputWrapper}>
                  <TextWrapper textStyle="textMid">جائزة البطولة</TextWrapper>
                  <NumberInput
                    placeHolder={"جائزة البطولة"}
                    value={prize}
                    setValue={setPrize}
                    className={styles.fullWidthControl}
                  />
                </div>
                <div className={`${styles.inputWrapper} ${styles.fullSpan}`}>
                  <TextWrapper textStyle="textMid"> وصف جائزة البطولة </TextWrapper>
                  <TextArea
                    value={prizeDescription}
                    onChange={(e) => setprizeDescription(e.target.value)}
                  />
                </div>
                <div className={`${styles.inputWrapper} ${styles.fullSpan}`}>
                  <TextWrapper textStyle="textMid">
                    وصف جائزة البطولة بالانجليزية
                  </TextWrapper>
                  <TextArea
                    value={enPrizeDescription}
                    onChange={(e) => setEnPrizeDescription(e.target.value)}
                  />
                </div>
              </div>
            </section>

            <section className={styles.section}>
              <div className={styles.sectionHeader}>
                <TextWrapper textStyle="textMid">صورة البطولة</TextWrapper>
              </div>
              <ImagesDropdown
                data={tournamentImages}
                value={image}
                setValue={setImage}
                className={styles.imagesGrid}
                itemClassName={styles.imageOption}
              />
            </section>
          </div>
          <div className={styles.createNewTournamentBtnWrapper}>
            <Button
              size="bigSize"
              variant="surfaceVariant"
              functionallity={handleTournamentUpdate}
            >
              <TextWrapper textStyle="textMid">التعديل على البطولة</TextWrapper>
            </Button>
          </div>
        </div>
      </SettingsPagesContainer>
    </div>
  );
};

export default EditTournament;
